import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()(theme => ({
  root: {
    "& .Toastify__toast": { borderRadius: theme.shape.borderRadius, padding: theme.spacing(2) },
    "& .Toastify__toast-theme--light.Toastify__toast--error": {
      backgroundColor: theme.palette.error.lighter,
      color: theme.palette.error.darker,
      border: `1px solid ${theme.palette.error.light}`,
      fontSize: theme.typography.body2.fontSize,
      "& .Toastify__close-button > svg": { fill: theme.palette.error.darker },
    },
    "& .Toastify__toast-theme--light.Toastify__toast--warning": {
      backgroundColor: theme.palette.warning.lighter,
      color: theme.palette.warning.darker,
      border: `1px solid ${theme.palette.warning.light}`,
      fontSize: theme.typography.body2.fontSize,
      "& .Toastify__close-button > svg": { fill: theme.palette.warning.darker },
    },
    "& .Toastify__toast-theme--light.Toastify__toast--success": {
      backgroundColor: theme.palette.success.lighter,
      color: theme.palette.success.darker,
      border: `1px solid ${theme.palette.success.light}`,
      fontSize: theme.typography.body2.fontSize,
      "& .Toastify__close-button > svg": { fill: theme.palette.success.darker },
    },
    "& .Toastify__toast-theme--light.Toastify__toast--info": {
      backgroundColor: theme.palette.info.lighter,
      color: theme.palette.info.darker,
      border: `1px solid ${theme.palette.info.light}`,
      fontSize: theme.typography.body2.fontSize,
      "& .Toastify__close-button > svg": { fill: theme.palette.info.darker },
    },
  },
}));
